import { useState } from "react";
import { Button } from "../../ui/button";
import { Input } from "../../ui/input";
import { Label } from "../../ui/label";
import { useForm } from "react-hook-form";
import {
  newPasswordSchema,
  UserNewPasswordFormValues,
} from "./user-zod-schema";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNavigate, useParams } from "react-router-dom";
import { PasswordToggle } from "../../../lib/showPassword";
import { userNewPassword } from "../../../../src/API/Users/userService";

export function PasswordChangeForm() {
  const { token } = useParams();
  const form = useForm<UserNewPasswordFormValues>({
    resolver: zodResolver(newPasswordSchema),
  });

  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const router = useNavigate();

  const onSubmit = async (data: UserNewPasswordFormValues) => {
    setLoading(true);
    await userNewPassword(data, token, router);
    setLoading(false);
  };

  return (
    <div className="pt-24 pb-80">
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="max-w-md p-6 mx-auto bg-white border rounded-lg shadow-md"
      >
        <h2 className="mb-6 text-xl font-semibold text-center">
          Nouveau votre mot de passe
        </h2>

        {/* New Password */}
        <div className="mb-4">
          <Label htmlFor="newPassword">Nouveau mot de passe</Label>
          <div className="relative">
            <Input
              id="newPassword"
              type={showNewPassword ? "text" : "password"}
              {...form.register("newPassword")}
            />
            <PasswordToggle
              showPassword={showNewPassword}
              setShowPassword={setShowNewPassword}
            />
          </div>
          {form.formState.errors.newPassword && (
            <p className="mt-1 text-sm text-red-500">
              {form.formState.errors.newPassword.message}
            </p>
          )}
        </div>

        {/* Confirm Password */}
        <div className="mb-6">
          <Label htmlFor="confirmPassword">
            Confirmer le nouveau mot de passe
          </Label>
          <div className="relative">
            <Input
              id="confirmPassword"
              type={showConfirmPassword ? "text" : "password"}
              {...form.register("confirmPassword")}
            />
            <PasswordToggle
              showPassword={showConfirmPassword}
              setShowPassword={setShowConfirmPassword}
            />
          </div>
          {form.formState.errors.confirmPassword && (
            <p className="mt-1 text-sm text-red-500">
              {form.formState.errors.confirmPassword.message}
            </p>
          )}
        </div>

        {/* Submit Button */}
        <Button type="submit" isLoading={loading} className="w-full">
          Modifier
        </Button>
      </form>
    </div>
  );
}
